export default [
  {
    path: 'newenergy',
    name: '新能源充电桩运营管理平台',
    meta: { title: '新能源充电桩运营管理平台' },
    component: () =>
      import(/* webpackChunkName: "newNyRecomment" */ '@/views/product/newenergy'),
  },
  {
    path: 'newenergy',
    name: '新能源充电站经营管理系统',
    meta: { title: '新能源充电站经营管理系统' },
    component: () =>
      import(/* webpackChunkName: "newNyRecomment" */ '@/views/product/newenergy'),
  },
  {
    path: 'newenergy',
    name: '企业充电服务系统',
    meta: { title: '企业充电服务系统' },
    component: () =>
      import(/* webpackChunkName: "newNyRecomment" */ '@/views/product/newenergy'),
  },
  {
    path: 'operation',
    name: '停车综合管理运营平台',
    meta: { title: '停车综合管理运营平台' },
    component: () =>
      import(/* webpackChunkName: "operationRecomment" */ '@/views/product/operation'),
  },
  {
    path: 'parkfees',
    name: '停车场收费管理系统',
    meta: { title: '停车场收费管理系统' },
    component: () =>
      import(/* webpackChunkName: "parkfeesRecomment" */ '@/views/product/parkfees'),
  },
  {
    path: 'Other',
    name: '其他停车场辅助系统',
    meta: { title: '其他停车场辅助系统' },
    component: () =>
      import(/* webpackChunkName: "otherRecomment" */ '@/views/product/Other'),
  },
  {
    path: 'cuntry',
    name: '城市智慧停车运营管理平台',
    meta: { title: '城市智慧停车运营管理平台' },
    component: () =>
      import(/* webpackChunkName: "cuntryRecomment" */ '@/views/product/cuntry'),
  },
  {
    path: 'cuntry',
    name: '城市道路停车收费巡检管理软件',
    meta: { title: '城市道路停车收费巡检管理软件' },
    component: () =>
      import(/* webpackChunkName: "cuntryRecomment" */ '@/views/product/cuntry'),
  },
  {
    path: 'cuntry',
    name: '市民车主停车服务应用',
    meta: { title: '市民车主停车服务应用' },
    component: () =>
      import(/* webpackChunkName: "cuntryRecomment" */ '@/views/product/cuntry'),
  },
];
